<template>
    <div class="flights-item-status">
        <vs-button @click="onOpen" type="flat" color="primary">
            გააქტიურება
        </vs-button>

        <vs-popup
            class="holamundo delivery"
            title="ადგილზე მიტანა"
            :active.sync="popupActive"
        >
            <vs-table
                stripe
                :hoverFlat="true"
                :data="userInfo.parcels"
                v-if="userInfo"
                max-items="5"
                pagination
            >
                <template slot="header">
                    <h3>ამანათები</h3>
                </template>
                <template slot="thead">
                    <vs-th> თრექინგ ID </vs-th>
                    <vs-th> წონა </vs-th>
                    <vs-th> ფასი </vs-th>
                    <vs-th> სტატუსი </vs-th>
                </template>

                <template slot-scope="{ data }">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr].tracking_number">
                            {{ data[indextr].tracking_number }}
                        </vs-td>

                        <vs-td :data="data[indextr].weight">
                            {{ Number(data[indextr].weight).toFixed(3) }} კგ
                        </vs-td>

                        <vs-td :data="data[indextr].weight_price">
                            {{ data[indextr].weight_price }} ლ
                        </vs-td>

                        <vs-td :data="data[indextr].payment_status">
                            {{
                                data[indextr].payment_status
                                    ? "გადახდილი"
                                    : "გადასახდელი"
                            }}
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>

            <vs-table stripe :hoverFlat="true" v-if="userInfo" class="mt-4">
                <template slot="header">
                    <h3>ზოგადი ინფორმაცია</h3>
                </template>
                <template slot="thead">
                    <vs-th> მისამაერთი </vs-th>
                    <vs-th> ქალაქი </vs-th>
                    <vs-th> ფასი </vs-th>
                    <vs-th> </vs-th>
                </template>

                <template>
                    <vs-tr>
                        <vs-td> {{ userInfo.user.address }} </vs-td>
                        <vs-td> {{ userInfo.user.city.name }} </vs-td>
                        <vs-td> {{ userInfo.price }} ლ</vs-td>
                        <vs-td>
                            <vs-button
                                @click="onOpenAddress"
                                color="primary"
                                type="flat"
                                size="small"
                            >
                                <vs-icon
                                    icon="mode_edit_outline"
                                    style="font-size: 18px"
                                ></vs-icon
                            ></vs-button>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>

            <vs-popup
                title="მისამართის რედაქტირება"
                :active.sync="addressModal"
            >
                <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                    <form
                        method="post"
                        @submit.prevent="handleSubmit(onSave)"
                        @keyup.enter="handleSubmit(onSave)"
                    >
                        <ValidationProvider
                            v-slot="{ errors }"
                            rules="required"
                            tag="div"
                        >
                            <div
                                :class="{
                                    'calculator-inpout': true,
                                    'is-invalid': errors[0] ? true : false,
                                }"
                            >
                                <input
                                    class="w-100"
                                    autocomplete="off"
                                    type="text"
                                    placeholder="მისამართი"
                                    v-model="address"
                                />
                            </div>
                            <span
                                v-if="errors[0]"
                                class="invalid-feedback"
                                role="alert"
                            >
                                <strong>{{ errors[0] }}</strong>
                            </span>
                        </ValidationProvider>

                        <button type="submit" class="calculator-button">
                            შენახვა
                        </button>
                    </form>
                </ValidationObserver>
            </vs-popup>

            <vs-button class="calculator-button mt-4" @click="onPay"
                >მიტანის აქტივაცია
            </vs-button>
        </vs-popup>
    </div>
</template>

<script>
import { defineComponent, ref } from "@vue/composition-api";
import { useDelivery } from "../hooks/delivery";
import { useUser } from "../hooks/user";
import Swal from "sweetalert2";

import { ValidationObserver, ValidationProvider } from "vee-validate";
import VSelect from "@alfsnd/vue-bootstrap-select";
export default defineComponent({
    props: {
        id: {
            type: String,
            default: "",
        },
    },
    components: {
        ValidationObserver,
        ValidationProvider,
        VSelect,
    },
    setup({ id }, { root }) {
        const { checkDelivery } = useDelivery();
        const { getCites, cites } = useUser();
        const userInfo = ref(null);
        const popupActive = ref(false);
        const addressModal = ref(false);

        const address = ref(null);

        const onOpen = async () => {
            root.$vs.loading({ color: "#f39120" });
            let res = await checkDelivery(id);
            root.$vs.loading.close();

            if (!res.delivery) {
                Swal.fire({
                    icon: "error",
                    title: res.massage,
                    confirmButtonText: "დახურვა",
                });

                return;
            }
            address.value = res.user.address;
            userInfo.value = res;
            popupActive.value = true;
        };
        const onOpenAddress = async () => {
            if (!cites.value) {
                root.$vs.loading({ color: "#f39120" });
                await getCites();
                root.$vs.loading.close();
            }
            addressModal.value = true;
        };

        const onSave = async () => {
            const { data } = await axios({
                url: `/api/delivery/change/address`,
                method: "POST",
                data: {
                    address: address.value,
                    flight_id: id,
                },
            });

            if (data.update) {
                addressModal.value = false;
                root.$vs.loading({ color: "#f39120" });
                userInfo.value = null;
                let res = await checkDelivery(id);
                root.$vs.loading.close();

                address.value = res.user.address;

                userInfo.value = res;
            }
        };

        const onPay = async () => {
            root.$vs.loading({ color: "#f39120" });
            const { data } = await axios({
                url: `/api/delivery/pay`,
                method: "POST",
                data: {
                    flight_id: id,
                },
            });
            popupActive.value = false;
            root.$vs.loading.close();
            if (!data.pay) {
                Swal.fire({
                    icon: "error",
                    title: data.massage,
                    confirmButtonText: "დახურვა",
                });
            } else {
                Swal.fire({
                    icon: "success",
                    title: data.massage,
                    confirmButtonText: "დახურვა",
                });
            }
        };

        return {
            popupActive,
            onOpen,
            userInfo,
            addressModal,

            onSave,
            address,

            onOpenAddress,
            cites,
            onPay,
        };
    },
});
</script>
